import CoinSelection from "./cardano/wallet/coinSelection.js";
import { getLovelace } from "./cardano/wallet/utils.js";
import store from "../store";
import AVAILABLE_CHAINS from "../contracts/availableChains.json";
const { VUE_APP_ENV } = process.env;
import api from "./api";

async function cardanoSerLib() {
  return await import(
    "@emurgo/cardano-serialization-lib-browser/cardano_serialization_lib.js"
  );
}
async function buffer() {
  return (await import("buffer/")).Buffer;
}

const env = VUE_APP_ENV !== "production" ? "staging" : "production";
// const networkParams = NETWORKS[env].polygon; // see network params for cardano testnet
const dev = env !== "production";

const CHAINS = AVAILABLE_CHAINS[env];

const supportedChainNames = [];
Object.keys(CHAINS).map(function (key) {
  supportedChainNames.push(CHAINS[key]);
});

class CardanoService {
  constructor(chainId = 1) {
    this.chainId = chainId;
    this.paymentAddr = "";
    this.address = "";
    this.signedNonce = "";
    this.store = store;
    this.availableUTXOs = [];
    this.potentialUTXOs = [];
    this.newSlot = false;
    this.slot = 0;
    this.providerOptions = {};
    this.lockingPolicyScript = { id: "", script: "", ttl: 0 };
    this.S = cardanoSerLib();
    this.Buffer = buffer();
    this.Loader = {
      Cardano: {},
    };
  }

  timeout(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async namiWallet() {
    if (window.cardano) {
      return window.cardano;
    } else {
      await this.timeout(300);
      return window.cardano;
    }
  }

  parseChainId = (id) => {
    return CHAINS[id] || "Selected network is not supported.";
  };

  parseChainName = (name) => {
    return name === "Cardano Testnet" ? "testnet" : "mainnet";
  };

  async connectToProvider() {
    if (typeof (await this.namiWallet()) != "undefined") {
      await (await await this.namiWallet()).enable();
      await this.fetchAddress();
      const chainId = await (await this.namiWallet()).getNetworkId();
      this.chainId = chainId;
      if (this.chainId != 1) {
        if (dev) console.log("tesnet");
      } else {
        if (dev) console.log("mainnet");
      }
    } else {
      console.log("Nami wallet not installed or browser is incompatible.");
    }
  }

  async isProviderConnected() {
    try {
      await (await this.namiWallet()).enable();
      if (this.paymentAddr == "") {
        return false;
      }
      return true;
    } catch (err) {
      if (dev)
        console.log(
          "Nami wallet not installed or browser is incompatible.",
          err
        );
      return false;
    }
  }

  async onChainChanged(handleChainChange) {
    if (await this.isProviderConnected()) {
      (await this.namiWallet()).onNetworkChange(async (id) => {
        await handleChainChange(id);
      });
    }
  }

  async onAccountChanged(handleAccountChange) {
    if (await this.isProviderConnected()) {
      (await this.namiWallet()).onAccountChange(
        async (accounts) => await handleAccountChange(accounts[0])
      );
    }
  }

  async getNetworkName() {
    const network = await this.getNetwork();
    return CHAINS[network] || "Unsupported network";
  }

  async getNetwork() {
    return await (await this.namiWallet()).getNetworkId();
  }

  async isValidNetwork() {
    const network = await this.getNetwork();
    return Boolean(CHAINS[network]);
  }

  async nftMint(ipfsHash, tokenName, description) {
    try {
      await this.PayTreasury();
    } catch (error) {
      console.log("Error when submitting tx");
      console.log(error);
      return { error: error.info || error.toString() };
    }
    let image = ipfsHash;
    let name = tokenName.replace(/[^A-Za-z!?]/g, "");
    let mintData = {
      name: name,
      description: description,
      image: image,
      file: ipfsHash,
      paymentAddress: this.paymentAddr,
      walletName: "Treasury",
    };
    await this.store.dispatch("cardanoFunctions/mintNFT", {
      mintData,
    });
  }

  async fetchAddress() {
    const S = await this.S;
    const address = await (await this.namiWallet()).getChangeAddress();
    this.address = address;
    const publicAddr = S.Address.from_bytes(
      Buffer.from(address, "hex")
    ).to_bech32();
    this.paymentAddr = publicAddr;
    return publicAddr;
  }

  async fetchBalance() {
    const balance = await getLovelace();
    return balance / 1000000;
  }

  async namiNftMint(
    ipfsHash,
    coverImageIpfs,
    tokenName,
    description,
    mimeType,
    tags,
    alternativeText
  ) {
    try {
      let metadata = {
        name: tokenName.replace(/\s/g, ""),
        quantity: "1",
        metadata: {
          name: tokenName,
          description: "",
          image: coverImageIpfs,
          tags: tags,
          alternativeText: "",
          files: [
            {
              name: tokenName,
              src: `ipfs://${ipfsHash}`,
              mediaType: mimeType,
            },
          ],
        },
      };
      if (description.length > 64) {
        metadata.metadata.description = description.match(/.{1,64}/g);
      } else {
        metadata.metadata.description = description;
      }
      if (alternativeText.length > 64) {
        metadata.metadata.alternativeText = alternativeText.match(/.{1,64}/g);
      } else {
        metadata.metadata.alternativeText = alternativeText;
      }
      let txHash = await this.MintTx(metadata);
      if (txHash.error) {
        console.log(`transaction error: ${txHash.error}`);
        return "rejected";
      }
      if (txHash == "no UTXOs") {
        return txHash;
      }
      this.availableUTXOs = this.potentialUTXOs;
      this.potentialUTXOs = [];
      return txHash.data;
    } catch (error) {
      console.log(error);
    }
  }

  async namiRoyaltyTokenMint(precentage) {
    const paymentAddresArray = this.paymentAddr.match(/.{1,64}/g);
    try {
      let metadata = {
        name: "",
        quantity: "1",
        metadata: {
          pct: (precentage / 100).toString(),
          addr: paymentAddresArray,
        },
      };
      let txHash = await this.MintRoyaltiesTx(metadata);
      if (txHash.error) {
        console.log(`transaction error: ${txHash.error}`);
        return "rejected";
      }
      if (txHash == "no UTXOs") {
        return txHash;
      }
      this.availableUTXOs = this.potentialUTXOs;
      this.potentialUTXOs = [];
      return txHash.data;
    } catch (error) {
      console.log(error);
    }
  }

  async signNonce(nonce) {
    const Buffer = await this.Buffer;
    try {
      this.signedNonce = await (
        await this.namiWallet()
      ).signData(this.address, Buffer.from(nonce).toString("hex"));
    } catch (error) {
      console.log(error);
      this.signedNonce = "rejected";
    }
  }

  async getProtocolParameters() {
    const S = await this.S;
    const latest_block = (await api.cardanoLatestBlock()).data;
    const slotnumber = latest_block.slot;
    if (this.slot != slotnumber) {
      this.newSlot = true;
      this.slot = slotnumber;
    } else {
      this.newSlot = false;
    }

    const p = (await api.cardanoProtocolParameters()).data;

    var value = {
      linearFee: S.LinearFee.new(
        S.BigNum.from_str(p.min_fee_a.toString()),
        S.BigNum.from_str(p.min_fee_b.toString())
      ),
      minUtxo: S.BigNum.from_str(p.min_utxo),
      poolDeposit: S.BigNum.from_str(p.pool_deposit),
      keyDeposit: S.BigNum.from_str(p.key_deposit),
      maxTxSize: p.max_tx_size,
      slot: slotnumber,
    };
    return value;
  }

  async createLockingPolicyScript(protocolParameters) {
    if (dev) console.log("protocolParameters");
    if (dev) console.log(protocolParameters);
    const Buffer = await this.Buffer;
    this.Loader.Cardano = await this.S;
    const slot = parseInt(protocolParameters.slot);
    if (this.lockingPolicyScript.ttl > slot + 100) {
      return this.lockingPolicyScript;
    }
    const ttl = slot + 1000;
    const address = Buffer.from(
      (await (await this.namiWallet()).getUsedAddresses())[0],
      "hex"
    );
    const paymentKeyHash = this.Loader.Cardano.BaseAddress.from_address(
      this.Loader.Cardano.Address.from_bytes(address)
    )
      .payment_cred()
      .to_keyhash();
    const nativeScripts = this.Loader.Cardano.NativeScripts.new();
    const script = this.Loader.Cardano.ScriptPubkey.new(paymentKeyHash);
    const nativeScript =
      this.Loader.Cardano.NativeScript.new_script_pubkey(script);
    const lockScript = this.Loader.Cardano.NativeScript.new_timelock_expiry(
      this.Loader.Cardano.TimelockExpiry.new(ttl)
    );
    nativeScripts.add(nativeScript);
    nativeScripts.add(lockScript);
    const finalScript = this.Loader.Cardano.NativeScript.new_script_all(
      this.Loader.Cardano.ScriptAll.new(nativeScripts)
    );
    const policyId = Buffer.from(
      this.Loader.Cardano.ScriptHash.from_bytes(
        finalScript.hash().to_bytes()
      ).to_bytes(),
      "hex"
    ).toString("hex");
    const lockPolicyScript = { id: policyId, script: finalScript, ttl };
    this.lockingPolicyScript = lockPolicyScript;
    return lockPolicyScript;
  }

  async submitTx(signedTx) {
    return await api.cardanoSubmitTx(signedTx.to_bytes());
  }

  async signTx(transaction) {
    const Buffer = await this.Buffer;
    const witnesses = await (
      await this.namiWallet()
    ).signTx(Buffer.from(transaction.to_bytes(), "hex").toString("hex"));
    const txWitnesses = transaction.witness_set();
    const txVkeys = txWitnesses.vkeys();
    const txScripts = txWitnesses.scripts();

    const addWitnesses = this.Loader.Cardano.TransactionWitnessSet.from_bytes(
      Buffer.from(witnesses, "hex")
    );
    const addVkeys = addWitnesses.vkeys();
    const addScripts = addWitnesses.scripts();

    const totalVkeys = this.Loader.Cardano.Vkeywitnesses.new();
    const totalScripts = this.Loader.Cardano.NativeScripts.new();

    if (txVkeys) {
      for (let i = 0; i < txVkeys.len(); i++) {
        totalVkeys.add(txVkeys.get(i));
      }
    }
    if (txScripts) {
      for (let i = 0; i < txScripts.len(); i++) {
        totalScripts.add(txScripts.get(i));
      }
    }
    if (addVkeys) {
      for (let i = 0; i < addVkeys.len(); i++) {
        totalVkeys.add(addVkeys.get(i));
      }
    }
    if (addScripts) {
      for (let i = 0; i < addScripts.len(); i++) {
        totalScripts.add(addScripts.get(i));
      }
    }

    const totalWitnesses = this.Loader.Cardano.TransactionWitnessSet.new();
    totalWitnesses.set_vkeys(totalVkeys);
    totalWitnesses.set_scripts(totalScripts);

    const signedTx = await this.Loader.Cardano.Transaction.new(
      transaction.body(),
      totalWitnesses,
      transaction.metadata()
    );
    return signedTx;
  }

  amountToValue = async (assets) => {
    const Buffer = await this.Buffer;
    //await this.Loader.load();
    const multiAsset = this.Loader.Cardano.MultiAsset.new();
    const lovelace = assets.find((asset) => asset.unit === "lovelace");
    const policies = [
      ...new Set(
        assets
          .filter((asset) => asset.unit !== "lovelace")
          .map((asset) => asset.unit.slice(0, 56))
      ),
    ];
    policies.forEach((policy) => {
      const policyAssets = assets.filter(
        (asset) => asset.unit.slice(0, 56) === policy
      );
      const assetsValue = this.Loader.Cardano.Assets.new();
      policyAssets.forEach((asset) => {
        assetsValue.insert(
          this.Loader.Cardano.AssetName.new(
            Buffer.from(asset.unit.slice(56), "hex")
          ),
          this.Loader.Cardano.BigNum.from_str(asset.quantity)
        );
      });
      multiAsset.insert(
        this.Loader.Cardano.ScriptHash.from_bytes(Buffer.from(policy, "hex")),
        assetsValue
      );
    });
    const value = this.Loader.Cardano.Value.new(
      this.Loader.Cardano.BigNum.from_str("0")
    );
    if (assets.length >= 1 || !lovelace) value.set_multiasset(multiAsset);
    return value;
  };

  asciiToHex = (str) => {
    var arr = [];
    for (var i = 0, l = str.length; i < l; i++) {
      var hex = Number(str.charCodeAt(i)).toString(16);
      arr.push(hex);
    }
    return arr.join("");
  };

  async MintRoyaltiesTx(metadata) {
    if (dev) console.log("Submitting Mint TX");
    const protocolParameters = await this.getProtocolParameters();
    const policy = await this.createLockingPolicyScript(protocolParameters);

    let name = metadata.name.slice(0, 32);

    const assets = [{ name: name, quantity: metadata.quantity.toString() }];

    const METADATA = {
      ...metadata.metadata,
    };

    try {
      if (dev) console.log("mintTx...");
      const transaction = await this.mintTx(
        assets,
        METADATA,
        policy,
        protocolParameters,
        "777"
      );
      if (transaction == "no UTXOs") {
        return transaction;
      }
      if (dev) console.log("signTx...");
      const signedTx = await this.signTx(transaction);
      if (dev) console.log("submitTx...");
      let txHash = "";
      txHash = await this.submitTx(signedTx);
      if (dev) console.log("Submited tx");
      if (dev) console.log("Transaction hash", txHash);
      return txHash;
    } catch (error) {
      console.log("Error when minting NFT");
      console.log(error);
      return { error: error.info || error.toString() };
    }
  }

  async MintTx(metadata) {
    if (dev) console.log("Submitting Mint TX");
    const protocolParameters = await this.getProtocolParameters();
    const policy = await this.createLockingPolicyScript(protocolParameters);

    let name = metadata.name.slice(0, 32);

    const assets = [{ name: name, quantity: metadata.quantity.toString() }];

    const METADATA = {
      [policy.id]: {
        [name.slice(0, 32)]: {
          ...metadata.metadata,
        },
      },
    };

    try {
      if (dev) console.log("mintTx...");
      const transaction = await this.mintTx(
        assets,
        METADATA,
        policy,
        protocolParameters
      );
      if (transaction == "no UTXOs") {
        return transaction;
      }
      if (dev) console.log("signTx...");
      const signedTx = await this.signTx(transaction);
      if (dev) console.log("submitTx...");
      const txHash = await this.submitTx(signedTx);
      if (dev) console.log("Submited tx");
      if (dev) console.log("Transaction hash", txHash);
      this.lockingPolicyScript.ttl = 0;
      return txHash;
    } catch (error) {
      console.log("Error when submitting tx");
      console.log(error);
      this.lockingPolicyScript.ttl = 0;
      return { error: error.info || error.toString() };
    }
  }

  async mintTx(
    assets,
    metadata,
    policy,
    protocolParameters,
    metadataLabel = "721"
  ) {
    const Buffer = await this.Buffer;
    const address = Buffer.from(
      (await (await this.namiWallet()).getUsedAddresses())[0],
      "hex"
    );
    const checkValue = await this.amountToValue(
      assets.map((asset) => ({
        unit: policy.id + this.asciiToHex(asset.name),
        quantity: asset.quantity,
      }))
    );

    const minAda = this.Loader.Cardano.min_ada_required(
      checkValue,
      protocolParameters.minUtxo
    );

    const _outputs = this.Loader.Cardano.TransactionOutputs.new();
    _outputs.add(
      this.Loader.Cardano.TransactionOutput.new(
        this.Loader.Cardano.Address.from_bytes(address),
        this.Loader.Cardano.Value.new(minAda)
      )
    );

    // Fix when you have utxo with low ada amount, it will require more ada for sending minting token
    _outputs.add(
      this.Loader.Cardano.TransactionOutput.new(
        this.Loader.Cardano.Address.from_bytes(address),
        this.Loader.Cardano.Value.new(
          this.Loader.Cardano.BigNum.from_str("1500000")
        )
      )
    );
    var utxos = [];
    if (!this.newSlot) {
      utxos = this.availableUTXOs;
    } else {
      utxos = (await (await this.namiWallet()).getUtxos()).map((utxo) =>
        this.Loader.Cardano.TransactionUnspentOutput.from_bytes(
          Buffer.from(utxo, "hex")
        )
      );
    }

    CoinSelection.setProtocolParameters(
      protocolParameters.minUtxo.to_str(),
      protocolParameters.linearFee.coefficient().to_str(),
      protocolParameters.linearFee.constant().to_str(),
      protocolParameters.maxTxSize.toString()
    );
    if (utxos.length < 1) {
      return "no UTXOs";
    }
    const selection = await CoinSelection.randomImprove(utxos, _outputs, 20);
    if (selection.input.length < 1) {
      return "no UTXOs";
    }
    this.potentialUTXOs = selection.remaining;

    const nativeScripts = this.Loader.Cardano.NativeScripts.new();
    nativeScripts.add(policy.script);
    const mintedAssets = this.Loader.Cardano.Assets.new();
    assets.forEach((asset) => {
      mintedAssets.insert(
        this.Loader.Cardano.AssetName.new(Buffer.from(asset.name)),
        this.Loader.Cardano.BigNum.from_str(asset.quantity)
      );
    });
    const mintedValue = this.Loader.Cardano.Value.new(
      this.Loader.Cardano.BigNum.from_str("1470000")
    );
    const multiAsset = this.Loader.Cardano.MultiAsset.new();
    multiAsset.insert(
      this.Loader.Cardano.ScriptHash.from_bytes(
        policy.script.hash().to_bytes()
      ),
      mintedAssets
    );
    mintedValue.set_multiasset(multiAsset);

    const mint = this.Loader.Cardano.Mint.new();
    const mintAssets = this.Loader.Cardano.MintAssets.new();
    assets.forEach((asset) => {
      mintAssets.insert(
        this.Loader.Cardano.AssetName.new(Buffer.from(asset.name)),
        this.Loader.Cardano.Int.new(
          this.Loader.Cardano.BigNum.from_str(asset.quantity)
        )
      );
    });
    mint.insert(
      this.Loader.Cardano.ScriptHash.from_bytes(
        policy.script
          .hash(this.Loader.Cardano.ScriptHashNamespace.NativeScript)
          .to_bytes()
      ),
      mintAssets
    );

    let value = this.Loader.Cardano.Value.new(
      this.Loader.Cardano.BigNum.from_str("0")
    );
    const inputs = this.Loader.Cardano.TransactionInputs.new();
    selection.input.forEach((utxo) => {
      inputs.add(
        this.Loader.Cardano.TransactionInput.new(
          utxo.input().transaction_id(),
          utxo.input().index()
        )
      );
      value = value.checked_add(utxo.output().amount());
    });
    value = value.checked_sub(mintedValue);

    const rawOutputs = this.Loader.Cardano.TransactionOutputs.new();
    rawOutputs.add(
      this.Loader.Cardano.TransactionOutput.new(
        this.Loader.Cardano.Address.from_bytes(address),
        value
      )
    );
    rawOutputs.add(
      this.Loader.Cardano.TransactionOutput.new(
        this.Loader.Cardano.Address.from_bytes(address),
        mintedValue
      )
    );
    const fee = this.Loader.Cardano.BigNum.from_str("0");

    const rawTxBody = this.Loader.Cardano.TransactionBody.new(
      inputs,
      rawOutputs,
      fee,
      policy.ttl
    );
    rawTxBody.set_mint(mint);

    let _metadata;
    if (metadata) {
      const generalMetadata =
        this.Loader.Cardano.GeneralTransactionMetadata.new();
      generalMetadata.insert(
        this.Loader.Cardano.BigNum.from_str(metadataLabel),
        this.Loader.Cardano.encode_json_str_to_metadatum(
          JSON.stringify(metadata)
        )
      );
      _metadata = this.Loader.Cardano.TransactionMetadata.new(generalMetadata);

      rawTxBody.set_metadata_hash(this.Loader.Cardano.hash_metadata(_metadata));
    }

    const witnesses = this.Loader.Cardano.TransactionWitnessSet.new();
    witnesses.set_scripts(nativeScripts);

    const dummyVkeyWitness =
      "8258208814c250f40bfc74d6c64f02fc75a54e68a9a8b3736e408d9820a6093d5e38b95840f04a036fa56b180af6537b2bba79cec75191dc47419e1fd8a4a892e7d84b7195348b3989c15f1e7b895c5ccee65a1931615b4bdb8bbbd01e6170db7a6831310c";

    const vkeys = this.Loader.Cardano.Vkeywitnesses.new();
    vkeys.add(
      this.Loader.Cardano.Vkeywitness.from_bytes(
        Buffer.from(dummyVkeyWitness, "hex")
      )
    );
    vkeys.add(
      this.Loader.Cardano.Vkeywitness.from_bytes(
        Buffer.from(dummyVkeyWitness, "hex")
      )
    );
    witnesses.set_vkeys(vkeys);

    const rawTx = this.Loader.Cardano.Transaction.new(
      rawTxBody,
      witnesses,
      _metadata
    );

    let minFee = this.Loader.Cardano.min_fee(
      rawTx,
      protocolParameters.linearFee
    );
    value = value.checked_sub(this.Loader.Cardano.Value.new(minFee));
    const outputs = this.Loader.Cardano.TransactionOutputs.new();
    outputs.add(
      this.Loader.Cardano.TransactionOutput.new(
        this.Loader.Cardano.Address.from_bytes(address),
        value
      )
    );
    outputs.add(
      this.Loader.Cardano.TransactionOutput.new(
        this.Loader.Cardano.Address.from_bytes(address),
        mintedValue
      )
    );

    const finalTxBody = this.Loader.Cardano.TransactionBody.new(
      inputs,
      outputs,
      minFee,
      policy.ttl
    );
    finalTxBody.set_mint(rawTxBody.multiassets());
    finalTxBody.set_metadata_hash(rawTxBody.metadata_hash());

    const finalWitnesses = this.Loader.Cardano.TransactionWitnessSet.new();
    finalWitnesses.set_scripts(nativeScripts);

    const transaction = this.Loader.Cardano.Transaction.new(
      finalTxBody,
      finalWitnesses,
      rawTx.metadata()
    );

    if (dev) console.log("Transaction");
    if (dev) console.log(transaction);

    return transaction;
  }

  async PayTreasury() {
    if (dev) console.log("Submitting Mint TX");
    const protocolParameters = await this.getProtocolParameters();
    if (dev) console.log(protocolParameters);

    if (dev) console.log("sendTX...");
    const transaction = await this.payTreasury(protocolParameters);
    if (dev) console.log("signTx...");
    const signedTx = await this.signTx(transaction);
    if (dev) console.log("submitTx...");
    const txHash = await this.submitTx(signedTx);
    if (dev) console.log("Submited tx");
    if (dev) console.log("Transaction hash", txHash);
    return txHash;
  }

  async payTreasury(protocolParameters) {
    const Buffer = await this.Buffer;
    // Treasury Address
    const sendAddress =
      "addr_test1qqu0jm92758mpt5m8qfh06gmlym86xpe0zsf7h4z3u09raxy03va7j6evqvw36k0dhvyzejql9fv8r5ett253apyngkq65pnkz";
    const address = Buffer.from(
      (await (await this.namiWallet()).getUsedAddresses())[0],
      "hex"
    );
    // fixed price 0.5 ADA
    let sendValue = this.Loader.Cardano.Value.new(
      this.Loader.Cardano.BigNum.from_str("500000")
    );

    const minAda = this.Loader.Cardano.min_ada_required(
      sendValue,
      protocolParameters.minUtxo
    );

    const _outputs = this.Loader.Cardano.TransactionOutputs.new();
    _outputs.add(
      this.Loader.Cardano.TransactionOutput.new(
        this.Loader.Cardano.Address.from_bytes(address),
        this.Loader.Cardano.Value.new(minAda)
      )
    );
    _outputs.add(
      this.Loader.Cardano.TransactionOutput.new(
        this.Loader.Cardano.Address.from_bech32(sendAddress),
        sendValue
      )
    );
    const utxos = (await (await this.namiWallet()).getUtxos()).map((utxo) =>
      this.Loader.Cardano.TransactionUnspentOutput.from_bytes(
        Buffer.from(utxo, "hex")
      )
    );
    CoinSelection.setProtocolParameters(
      protocolParameters.minUtxo.to_str(),
      protocolParameters.linearFee.coefficient().to_str(),
      protocolParameters.linearFee.constant().to_str(),
      protocolParameters.maxTxSize.toString()
    );
    const selection = await CoinSelection.randomImprove(utxos, _outputs, 20);
    if (dev) console.log("selection");
    if (dev) console.log(selection);

    const inputs = this.Loader.Cardano.TransactionInputs.new();
    if (dev) console.log("inputs: ");
    if (dev) console.log(inputs);
    let value = this.Loader.Cardano.Value.new(
      this.Loader.Cardano.BigNum.from_str("0")
    );

    selection.input.forEach((utxo) => {
      inputs.add(
        this.Loader.Cardano.TransactionInput.new(
          utxo.input().transaction_id(),
          utxo.input().index()
        )
      );
      value = value.checked_add(utxo.output().amount());
    });

    const rawOutputs = this.Loader.Cardano.TransactionOutputs.new();
    rawOutputs.add(
      this.Loader.Cardano.TransactionOutput.new(
        this.Loader.Cardano.Address.from_bytes(address),
        value
      )
    );
    rawOutputs.add(
      this.Loader.Cardano.TransactionOutput.new(
        this.Loader.Cardano.Address.from_bech32(sendAddress),
        sendValue
      )
    );
    const fee = this.Loader.Cardano.BigNum.from_str("0");

    const rawTxBody = this.Loader.Cardano.TransactionBody.new(
      inputs,
      rawOutputs,
      fee
    );

    const witnesses = this.Loader.Cardano.TransactionWitnessSet.new();
    const dummyVkeyWitness =
      "8258208814c250f40bfc74d6c64f02fc75a54e68a9a8b3736e408d9820a6093d5e38b95840f04a036fa56b180af6537b2bba79cec75191dc47419e1fd8a4a892e7d84b7195348b3989c15f1e7b895c5ccee65a1931615b4bdb8bbbd01e6170db7a6831310c";

    const vkeys = this.Loader.Cardano.Vkeywitnesses.new();
    vkeys.add(
      this.Loader.Cardano.Vkeywitness.from_bytes(
        Buffer.from(dummyVkeyWitness, "hex")
      )
    );
    vkeys.add(
      this.Loader.Cardano.Vkeywitness.from_bytes(
        Buffer.from(dummyVkeyWitness, "hex")
      )
    );
    witnesses.set_vkeys(vkeys);

    const rawTx = this.Loader.Cardano.Transaction.new(rawTxBody, witnesses);

    let minFee = this.Loader.Cardano.min_fee(
      rawTx,
      protocolParameters.linearFee
    );
    value = value.checked_sub(this.Loader.Cardano.Value.new(minFee));
    value = value.checked_sub(sendValue);

    const outputs = this.Loader.Cardano.TransactionOutputs.new();
    outputs.add(
      this.Loader.Cardano.TransactionOutput.new(
        this.Loader.Cardano.Address.from_bytes(address),
        value
      )
    );
    outputs.add(
      this.Loader.Cardano.TransactionOutput.new(
        this.Loader.Cardano.Address.from_bech32(sendAddress),
        sendValue
      )
    );
    const finalTxBody = this.Loader.Cardano.TransactionBody.new(
      inputs,
      outputs,
      minFee
    );

    const finalWitnesses = this.Loader.Cardano.TransactionWitnessSet.new();

    const transaction = this.Loader.Cardano.Transaction.new(
      finalTxBody,
      finalWitnesses
    );

    if (dev) console.log("Transaction");
    if (dev) console.log(transaction);
    // const size = transaction.to_bytes().length * 2;
    // if (size > protocolParameters.maxTxSize) throw ERROR.txTooBig;

    return transaction;
  }
}

export default CardanoService;
